/**
 * mr-tier-picker-prices.js -- Step 2 "Choose wheelchairs" reskin, Waqf
 * Wheelchair ONLY for now (2026-07-15). Additively injects each existing
 * Dawn variant-picker radio's real price into its own <label>, read from
 * the JSON price map snippets/mr-c-tier-picker.liquid embeds as a
 * <script type="application/json"> child (Dawn's own established pattern
 * for this exact purpose -- see product-variant-picker.liquid's own
 * data-selected-variant script).
 *
 * Deliberately does NOT touch any input's type/name/value/id/checked
 * state and does NOT create new inputs, cards, or a second selector --
 * it only appends a <span> inside labels that already exist, matching
 * the "DOM-walk + inject, never touch functional attributes" pattern
 * already proven for Infinite Options absorption (mr-io-absorb.js).
 * Only ever runs inside `.mr-c-tier-picker--styled` -- a no-op on every
 * other product's page, since that class is only added by
 * mr-c-tier-picker.liquid when the calling block has an explicit Step 2
 * title set (Wheelchair only right now).
 *
 * MutationObserver fix (2026-07-15, same day): confirmed live via QA
 * click-test that Dawn's own <product-info> custom element morphs the
 * variant-picker fieldset's label markup on every variant change (it
 * fetches a fresh section render and swaps the labels in to update
 * price/availability state) -- this silently strips our injected spans
 * and data-mr-priced guard the moment a shopper picks a different
 * quantity, since those spans are DOM-injected, not part of Dawn's own
 * server-rendered markup. The JSON price-map script survives (it lives
 * in the wrapper mr-c-tier-picker.liquid renders around Dawn's picker,
 * which Dawn's morph never touches), so re-running applyPrices() after
 * each morph is all that's needed. Observing the outer
 * `.mr-c-tier-picker--styled` root (not the fieldset itself) is
 * deliberate: it survives regardless of whether Dawn morphs the
 * fieldset's children in place or replaces the whole fieldset element,
 * since either case is still a childList mutation somewhere in the
 * root's subtree. applyPrices() re-queries the fieldset/inputs fresh
 * every call and is idempotent per label (data-mr-priced guard), so
 * re-invoking it on every observed mutation -- including the ones our
 * own injected spans cause -- is always safe and self-terminating.
 */
(function () {
  'use strict';

  function applyPrices(root) {
    var scriptEl = root.querySelector('script[data-mr-tier-prices]');
    if (!scriptEl) return;

    var prices;
    try {
      prices = JSON.parse(scriptEl.textContent);
    } catch (e) {
      return;
    }

    var inputs = root.querySelectorAll('fieldset.product-form__input--pill input[type="radio"]');
    inputs.forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') return;
      if (label.hasAttribute('data-mr-priced')) return;

      var price = prices[input.value];
      if (!price) return;

      var firstText = null;
      for (var i = 0; i < label.childNodes.length; i++) {
        var node = label.childNodes[i];
        if (node.nodeType === 3 && node.textContent.trim() !== '') {
          firstText = node;
          break;
        }
      }
      if (firstText) {
        var qty = document.createElement('span');
        qty.className = 'mr-c-tier-picker__qty';
        qty.textContent = firstText.textContent.trim();
        label.replaceChild(qty, firstText);
      }

      var priceEl = document.createElement('span');
      priceEl.className = 'mr-c-tier-picker__price';
      priceEl.textContent = price;
      label.appendChild(priceEl);

      label.setAttribute('data-mr-priced', 'true');
    });
  }

  function observe(root) {
    var observer = new MutationObserver(function () {
      applyPrices(root);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('.mr-c-tier-picker--styled').forEach(function (root) {
      applyPrices(root);
      observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
